<div class="grid grid-cols-12 gap-4">
  <div class="col-span-12">
    <app-dashboard-search (openAddDialog)="toggleAddDialog()"></app-dashboard-search>
  </div>

  <div class="col-span-12">
    <app-dashboard-medical-search />
  </div>

  @if (
    loadingPendingOrigins || pendingOriginAnimals.length > 0 ||
    loadingPendingSecuredByPolice || pendingSecuredByPoliceAnimals.length > 0 ||
    loadingPendingWhereabouts || pendingWhereaboutAnimals.length > 0
  ) {
    <div class="col-span-12">
      <div class="bg-white rounded-lg shadow-md p-1 pt-6">
        <h2 class="p-1 text-center text-xl font-semibold mb-5">
          {{ 'dashboard.pendingHeadline' | transloco }}
        </h2>
        <p-tabs value="0">
          <p-tablist>
            <p-tab value="0">{{ 'dashboard.pendingOrigins.headline' | transloco }}</p-tab>
            <p-tab value="1">{{ 'dashboard.pendingSecuredByPolice.headline' | transloco }}</p-tab>
            <p-tab value="2">{{ 'dashboard.pendingWhereabouts.headline' | transloco }}</p-tab>
          </p-tablist>
          <p-tabpanels>
            <p-tabpanel value="0">
              @if (loadingPendingOrigins) {
                <div class="flex justify-center items-center py-10">
                  <p-progressSpinner></p-progressSpinner>
                </div>
              } @else {
                <app-animal-list-item
                  [animals]="pendingOriginAnimals"
                  [pageable]="true"
                  [pageSize]="6"
                />
              }
            </p-tabpanel>
            <p-tabpanel value="1">
              @if (loadingPendingSecuredByPolice) {
                <div class="flex justify-center items-center py-10">
                  <p-progressSpinner></p-progressSpinner>
                </div>
              } @else {
                <app-animal-list-item
                  [animals]="pendingSecuredByPoliceAnimals"
                  [pageable]="true"
                  [pageSize]="6"
                />
              }
            </p-tabpanel>
            <p-tabpanel value="2">
              @if (loadingPendingWhereabouts) {
                <div class="flex justify-center items-center py-10">
                  <p-progressSpinner></p-progressSpinner>
                </div>
              } @else {
                <app-animal-list-item
                  [animals]="pendingWhereaboutAnimals"
                  [pageable]="true"
                  [pageSize]="6"
                />
              }
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
      </div>
    </div>
  }

  <div class="col-span-12">
    <app-dashboard-due-treatments />
  </div>

  <div class="col-span-12">
    <div class="bg-white rounded-lg shadow-md p-1 pt-6">
      <h2 class="p-1 text-center text-xl font-semibold mb-5">
        {{ 'dashboard.newAnimals.headline' | transloco }}
      </h2>
      <div *ngIf="loadingNewAnimals" class="flex justify-center items-center py-10">
        <p-progressSpinner/>
      </div>
      @if (!loadingNewAnimals) {
        <app-animal-list-item
          [animals]="newAnimals"
          [pageable]="true"
          [pageSize]="6"
        />
      }
    </div>
  </div>
</div>
@if (addDialogVisible) {
  <app-animal-add-dialog/>
}
